import { ALTERAR_DETALHAMENTO_ROTA_ITINERARIO } from '../types'
import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export function alterarExibicaoDetalhamentoRotaItinerario(rota, novaPesquisa) {
  const urlItinerario = `${URL}/itinerario/rota/${rota.id}/${rota.empresaId}/itinerarios`
  return dispatch => {
    if(!rota.trechoFoiPesquisado || novaPesquisa) {
      axios.get(urlItinerario, SLOW_REQUEST_CONFIG).then(
        response => {
          return dispatch({
            type: ALTERAR_DETALHAMENTO_ROTA_ITINERARIO,
            payload: {
              itinerarios: response.data.itinerarios,
              trechos: response.data.trechos,
              rota: rota, 
              novaPesquisa: novaPesquisa
            }
          })
        }
      )
    } else {
      return dispatch({
        type: ALTERAR_DETALHAMENTO_ROTA_ITINERARIO,
        payload: {
          rota: rota,
          trechos: null
        }
      })
    }
  }
}